export default "__VITE_ASSET__BfXdcYIp__"